<template>
  <div class="warn">
    <van-nav-bar title="警告" left-arrow @click-left="$goBack()"/>
    <div class="content" >
    <van-row type="flex" justify="center" >
      <van-col span="5">
          <div><van-icon name="info-o" /></div>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col v-if="code=='10'" >
          <div class="msg">登录失败！</div>
      </van-col>
      <van-col v-if="code=='00'" >
          <div class="msg">页面初始化失败,参数不全</div>
      </van-col>
      <van-col v-if="code=='01'" >
          <div class="msg">获取主页信息失败,网络连接失败!</div>
      </van-col>
      <van-col v-if="code=='02'" >
        <div class="msg">获取用户信息失败,非法参数!</div>
      </van-col>
    </van-row>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      code:this.$route.params.code
    }
  },
  computed: {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .warn {
    background-color: #fff;
    .content{
        padding-top: 30px;
        .van-icon{
          font-size: 80px;
          color: #ff0000;
        }
    }

    .msg{
      padding-top: 10px;
      font-size: 15px;
      color: #666666;
    }
  }
</style>
